import { ServiceRequest } from "../../api/ServiceRequest";

export class PtsAlertRequest extends ServiceRequest {
  startDate?: string; // ISO 8601 string
  endDate?: string;
  deviceType?: string;
  deviceNumber?: number;
  state?: string;
  code?: number;

  constructor(init?: Partial<PtsAlertRequest>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getStartDate(): string | undefined {
    return this.startDate;
  }
  setStartDate(value: string | undefined): void {
    this.startDate = value;
  }

  getEndDate(): string | undefined {
    return this.endDate;
  }
  setEndDate(value: string | undefined): void {
    this.endDate = value;
  }

  getDeviceType(): string | undefined {
    return this.deviceType;
  }
  setDeviceType(value: string | undefined): void {
    this.deviceType = value;
  }

  getDeviceNumber(): number | undefined {
    return this.deviceNumber;
  }
  setDeviceNumber(value: number | undefined): void {
    this.deviceNumber = value;
  }

  getState(): string | undefined {
    return this.state;
  }
  setState(value: string | undefined): void {
    this.state = value;
  }

  getCode(): number | undefined {
    return this.code;
  }
  setCode(value: number | undefined): void {
    this.code = value;
  }
}
